/* LimuPet Header — davranışlar (harici kütüphane yok) */
(function () {
  'use strict';

  var root = document.querySelector('[data-lph]');
  if (!root || root.__lphInit) return;
  root.__lphInit = true;

  var header = root.querySelector('[data-lph-header]');
  var sentinel = root.querySelector('[data-lph-sentinel]');
  var menu = root.querySelector('[data-lph-menu]');
  var search = root.querySelector('[data-lph-search]');
  var loading = root.querySelector('[data-lph-loading]');
  var html = document.documentElement;
  var lastFocus = null;

  /* ── Kaydırınca küçülen yüzen header ──
     Sentinel (header'ın doğal konumu) görünüm alanının üstüne çıkınca "scrolled".
     IntersectionObserver yerine scroll'u doğrudan okuyoruz: tema editörü iframe'inde de güvenilir. */
  if (sentinel && header) {
    var ticking = false;
    var update = function () {
      ticking = false;
      header.classList.toggle('is-scrolled', sentinel.getBoundingClientRect().top < 0);
    };
    var onScroll = function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    };
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function lockScroll() {
    html.classList.toggle('lph-lock', !!(isOpen(menu) || isOpen(search)));
  }
  function isOpen(el) {
    return !!el && !el.hasAttribute('hidden');
  }

  /* ── Menü ── */
  function openMenu(trigger) {
    if (!menu) return;
    lastFocus = trigger || document.activeElement;
    menu.removeAttribute('hidden');
    lockScroll();
    var first = menu.querySelector('a, button');
    if (first) setTimeout(function () { first.focus(); }, 50);
  }
  function closeMenu() {
    if (!menu || !isOpen(menu)) return;
    menu.setAttribute('hidden', '');
    /* Açık akordiyonları kapat */
    menu.querySelectorAll('[data-lph-acc-btn][aria-expanded="true"]').forEach(function (b) {
      toggleAcc(b, false);
    });
    lockScroll();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function toggleAcc(btn, force) {
    var acc = btn.closest('[data-lph-acc]');
    var panel = acc && acc.querySelector(':scope > [data-lph-acc-panel]');
    if (!panel) return;
    var open = typeof force === 'boolean' ? force : btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) panel.removeAttribute('hidden');
    else panel.setAttribute('hidden', '');
    /* Üst seviyede aynı anda tek akordiyon açık kalsın (ikas davranışı) */
    if (open && acc.parentElement) {
      acc.parentElement.querySelectorAll(':scope > [data-lph-acc] > [data-lph-acc-btn][aria-expanded="true"]').forEach(function (other) {
        if (other !== btn) toggleAcc(other, false);
      });
    }
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    var openMenuBtn = t.closest('[data-lph-open-menu]');
    if (openMenuBtn) { openMenu(openMenuBtn); return; }
    if (t.closest('[data-lph-close-menu]')) { closeMenu(); return; }
    var acc = t.closest('[data-lph-acc-btn]');
    if (acc) { toggleAcc(acc); return; }
    if (t.closest('[data-lph-open-search]')) {
      var s = t.closest('[data-lph-open-search]');
      closeMenu();
      openSearch(s);
      return;
    }
    if (t.closest('[data-lph-close-search]')) { closeSearch(); return; }
    /* Menü içinde bir linke tıklanınca kapat */
    if (menu && menu.contains(t) && t.closest('a[href]')) closeMenu();
  });

  /* ── Arama ── */
  var input = search && search.querySelector('[data-lph-search-input]');
  var results = search && search.querySelector('[data-lph-search-results]');
  var status = search && search.querySelector('[data-lph-search-status]');
  var allBtn = search && search.querySelector('[data-lph-search-all]');
  var timer = null;
  var reqId = 0;

  function openSearch(trigger) {
    if (!search) return;
    lastFocus = trigger || document.activeElement;
    search.removeAttribute('hidden');
    lockScroll();
    resetSearch();
    setTimeout(function () { if (input) input.focus(); }, 80);
  }
  function closeSearch() {
    if (!search || !isOpen(search)) return;
    search.setAttribute('hidden', '');
    lockScroll();
    resetSearch();
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function resetSearch() {
    if (input) input.value = '';
    if (results) results.innerHTML = '';
    if (allBtn) allBtn.setAttribute('hidden', '');
    if (status) { status.textContent = 'Aramak istediğiniz ürünü yazın...'; status.removeAttribute('hidden'); }
  }

  function money(v) {
    var n = parseFloat(v);
    if (isNaN(n)) return '';
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'TRY';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur }).format(n);
    } catch (err) {
      return n.toFixed(2) + ' ' + cur;
    }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function renderRow(p) {
    var img = p.featured_image && p.featured_image.url;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=180';
    var price = parseFloat(p.price);
    var compare = parseFloat(p.compare_at_price_max);
    var onSale = compare > price;
    return (
      '<a class="lph-srow" href="' + esc(p.url) + '">' +
      '<div class="lph-srow-img">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div>' +
      '<div class="lph-srow-info"><div class="lph-srow-name">' + esc(p.title) + '</div>' +
      '<div class="lph-srow-price">' +
      (onSale ? '<b>' + money(price) + '</b><s>' + money(compare) + '</s>' : '<b>' + money(price) + '</b>') +
      '</div></div></a>'
    );
  }

  function runSearch(q) {
    var id = ++reqId;
    status.textContent = 'Aranıyor...';
    status.removeAttribute('hidden');
    results.innerHTML = '';
    allBtn.setAttribute('hidden', '');
    var url = search.getAttribute('data-suggest-url') + '.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (id !== reqId) return;
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        if (!products.length) { status.textContent = 'Sonuç bulunamadı'; return; }
        status.setAttribute('hidden', '');
        results.innerHTML = products.map(renderRow).join('');
        allBtn.removeAttribute('hidden');
      })
      .catch(function () {
        if (id === reqId) status.textContent = 'Sonuç bulunamadı';
      });
  }

  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { ++reqId; resetSearchResultsOnly(); return; }
      timer = setTimeout(function () { runSearch(q); }, 280);
    });
  }
  function resetSearchResultsOnly() {
    results.innerHTML = '';
    allBtn.setAttribute('hidden', '');
    status.textContent = 'Aramak istediğiniz ürünü yazın...';
    status.removeAttribute('hidden');
  }
  if (allBtn) {
    allBtn.addEventListener('click', function () {
      var f = search.querySelector('form');
      if (f && input.value.trim()) f.submit();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (isOpen(search)) closeSearch();
    else if (isOpen(menu)) closeMenu();
  });

  /* ── Sepet: mobil ikon Dawn'ın #cart-icon-bubble'ı ile senkron ve çekmeceyi açar ── */
  var bubble = document.getElementById('cart-icon-bubble');
  var mirror = root.querySelector('[data-lph-cart-mirror]');
  if (bubble && mirror) {
    var sync = function () { mirror.innerHTML = bubble.innerHTML; };
    new MutationObserver(sync).observe(bubble, { childList: true, subtree: true });
    mirror.addEventListener('click', function (e) {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        e.preventDefault();
        drawer.open(mirror);
      }
    });
  }

  /* ── Sayfa geçiş animasyonu ── */
  if (loading) {
    window.addEventListener('pageshow', function () { loading.setAttribute('hidden', ''); });
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.origin !== location.origin) return;
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
      /* Aynı sayfa (query/hash değişimi, varyant seçimi) → animasyon yok */
      if (url.pathname === location.pathname) return;
      loading.removeAttribute('hidden');
    });
  }
})();
